import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-amarjeet',
  templateUrl: './amarjeet.component.html',
  styleUrls: ['./amarjeet.component.scss']
})
export class AmarjeetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAmarjeet();
  }
}
